<template>
  <div class="m-nav-mobile__collapse">
    <button type="button" class="m-nav-mobile__collapse-toggle" :class="{ 'is-active': isOpen }" @click.prevent="toggle" :aria-expanded="isOpen ? 'true' : 'false'">
      <span class="m-nav-mobile__collapse-label" v-text="title"></span>
      <svg class="m-nav-mobile__collapse-icon" aria-hidden="true">
        <use :xlink:href="$root.spritePath + '#btn-arrow-down'" />
      </svg>
    </button>
    <transition @before-enter="beforeEnter" @enter="enter" @after-enter="afterEnter" @before-leave="beforeLeave" @leave="leave" @after-leave="afterLeave">
      <div v-if="isOpen" class="m-nav-mobile__collapse-content">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>

<script>
  export default {
    props: {
      title: {
        type: String,
        required: true,
      },
    },

    data: () => ({
      isOpen: false,
    }),

    methods: {
      open() {
        this.isOpen = true;
      },

      close() {
        this.isOpen = false;
      },

      toggle() {
        this.isOpen ? this.close() : this.open();
      },

      beforeEnter(element) {
        requestAnimationFrame(() => {
          if (!element.style.height) {
            element.style.height = "0px";
          }

          element.style.display = null;
        });
      },

      enter(element) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            element.style.height = `${element.scrollHeight}px`;
          });
        });
      },

      afterEnter(element) {
        element.style.height = null;
      },

      beforeLeave(element) {
        requestAnimationFrame(() => {
          if (!element.style.height) {
            element.style.height = `${element.offsetHeight}px`;
          }
        });
      },

      leave(element) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            element.style.height = "0px";
          });
        });
      },

      afterLeave(element) {
        element.style.height = null;
      },
    },
  }
</script>
